import genericOptionsUrl from './genericOptions.html';
export default {
  templateUrl: genericOptionsUrl,
  controllerAs: 'ctrl',
  controller: class {
    $onInit() {
      if (!this.filterProperty) {
        this.filterProperty = 'locationIds';
      }
    }

    filterExplicitlySelected = (item) =>
      this.filter[this.filterProperty] &&
      this.filter[this.filterProperty].length &&
      this.filter[this.filterProperty].includes(item.id);

    filterNotExplicitlySelected = (item) =>
      !this.filter[this.filterProperty] ||
      !this.filter[this.filterProperty].length ||
      !this.filter[this.filterProperty].includes(item.id);
  },
  bindings: {
    toggleFilter: '&',
    items: '=',
    filter: '=',
    filterDisplayProperty: '@?',
    filterProperty: '@?',
    hideMarker: '<?',
  },
  require: {
    dropdownFilterCtrl: '^?dropdownFilter',
  },
};
